import { useState } from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const DefaultLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (    
      <div className="flex h-screen overflow-hidden">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex z-0	flex-1 flex-col overflow-y-hidden overflow-x-hidden">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main className='bg-[#F4F6F9]  z-0 p-8'>
            <div className="mx-auto max-w-screen-2xl">
              <Outlet />
            </div>
          </main>
        </div>
      </div>    
  );
};

export default DefaultLayout;